@if (goodsItem) {
  <app-consignment-details-alerts></app-consignment-details-alerts>
  <div class="modal-header">
    <div class="flex-container align-items-center">
      <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-file-lines text-muted"></i>
      </div>
      <button class="btn btn-link p-0 page-title align-baseline" (click)="processModelAndOpenMasterConsignment()">
        <span class="page-title">{{ consignmentProcess.consignmentMasterLevel.consignmentNumber }}</span>
      </button>
      <div class="d-inline-flex mx-2">
        <i class="fa fa-fw fa-light fa-lg fa-chevron-right text-muted"></i>
      </div>
      @if (houseConsignment) {
        <div class="d-inline-flex me-1">
          <i class="fa fa-kit fa-fw fa-light fa-lg fa-pb-file-line text-muted"></i>
        </div>
        <button class="btn btn-link p-0 page-title align-baseline" (click)="processModelAndOpenHouseConsignment()">
          <span class="page-title">{{ houseConsignment.consignmentNumber }}</span>
        </button>
        <div class="d-inline-flex mx-2">
          <i class="fa fa-fw fa-light fa-lg fa-chevron-right text-muted"></i>
        </div>
      }
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-box-open text-muted"></i>
      </div>
      <span class="page-title">{{ goodsItem.commodity?.descriptionOfGoods | middleEllipsis }}</span>
    </div>
  </div>
  <div class="modal-body p-0">
    <app-tab-panel [sticky]="true" [alwaysRender]="true" (tabChange)="onTabChange($event)">
      <app-tab-item [templateRef]="detailsRef">
        <span class="tab-item">
          <span errorIndicator [mainPredicate]="detailsPredicate" [overrideRef]="elementRef"></span>
          <span>Details</span>
        </span>
        <ng-template #detailsRef>
          <div class="container py-3">
            <div class="card">
              <div class="card-body p-5">
                <div class="row gy-4 my-0">
                  <h5 class="h1 col-12 m-0">Goods details</h5>
                  @if (editMode) {
                    <span>If you add a CN code, we can automatically match and prefill the ‘Customs Union and Statistics number’ and ‘The United Nations Dangerous Goods identifier number’.</span>
                  }
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="HS or CN code" class="col-12"
                                      [(value)]="goodsItem.commodity" [editMode]="editMode"
                                      [includeMargin]="false" [formatter]="commodityFormatter"
                                      [checkForErrors]="true">
                        <div class="d-block mb-2">
                          <span class="text-secondary">Harmonized System sub–heading code (6 digits) or Combined nomenclature code (8 digits)</span>
                        </div>
                        <app-search [(ngModel)]="goodsItem.commodity" [inputFormatter]="commodityFormatter"
                                    [resultFormatter]="utils.commodityFormatter"
                                    [searchFunction]="utils.findCommodities"
                                    [minCharacters]="1" [required]="isHSCodeRequired"
                                    (ngModelChange)="backupCommodity($event)"
                                    dataKey="code" placeholder="Select a HS or CN code"></app-search>
                      </app-form-field>
                    </div>
                  </div>
                  @if (goodsItem.commodity) {
                    <div class="col-12 mt-2">
                      <div class="row">
                        <app-form-field label="Goods description" class="col-12"
                                        [(value)]="goodsDescriptionOption" [includeMargin]="false"
                                        [editMode]="editMode" [renderOptional]="false"
                                        [formatter]="refData.enumFormatter">
                          <app-radio [(ngModel)]="goodsDescriptionOption" [inline]="true"
                                     [options]="goodsDescriptionOptions"
                                     [formatter]="goodsDescriptionOptionFormatter"
                                     (ngModelChange)="goodsDescriptionOptionChanged($event)"
                                     required></app-radio>
                        </app-form-field>
                      </div>
                    </div>
                    @if (goodsDescriptionOption === 'Write my own') {
                      <div class="col-12 mt-2">
                        <div class="row">
                          <app-form-field label="Description of goods" class="col-12"
                                          [(value)]="goodsItem.commodity.descriptionOfGoods" [includeMargin]="false"
                                          [editMode]="editMode" [renderOptional]="false"
                                          [checkForErrors]="true">
                            <input class="input-group form-control" [(ngModel)]="goodsItem.commodity.descriptionOfGoods"
                                   required/>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="UNDG number" class="col-12"
                                        [(value)]="goodsItem.commodity.dangerousGoods" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="refData.dangerInformationFormatter">
                          <div class="d-block mb-2">
                            <span class="text-secondary">The United Nations Dangerous Goods identifier number</span>
                          </div>
                          <app-search [(ngModel)]="goodsItem.commodity.dangerousGoods" dataKey="name"
                                      [inputFormatter]="refData.dangerInformationFormatter"
                                      [searchFunction]="refData.findDangerInformation"
                                      [resultFormatter]="refData.dangerInformationFormatter"
                                      placeholder="Find by name or UN code"></app-search>
                        </app-form-field>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="CUS number" class="col-12"
                                        [(value)]="goodsItem.commodity.cusCode" [editMode]="editMode"
                                        [includeMargin]="false">
                          <div class="d-block mb-2">
                            <span class="text-secondary">Customs Union and Statistics number is the identifier assigned
                              within the European Customs Inventory of Chemical Substances (ECICS) to mainly chemical
                            substances and preparations</span>
                          </div>
                          <input class="input-group form-control" [(ngModel)]="goodsItem.commodity.cusCode"/>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Gross weight (kg)" class="col-6 col-md-3"
                                      [(value)]="goodsItem.grossWeight" [editMode]="editMode"
                                      [includeMargin]="false" [compare]="bulkDischargeWeight"
                                      compareHeader="New data from Terminal"
                                      [checkForErrors]="true">
                        <input class="input-group form-control" type="number" step="any" required
                               [(ngModel)]="goodsItem.grossWeight"/>
                      </app-form-field>
                      <app-form-field label="Net weight (kg)" class="col-6 col-md-3"
                                      [(value)]="goodsItem.netWeight" [editMode]="editMode"
                                      [includeMargin]="false">
                        <input class="input-group form-control" type="number" step="any"
                               [(ngModel)]="goodsItem.netWeight"/>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <app-form-field label="Minimum temperature (°C)" class="col col-md-5"
                                      [(value)]="goodsItem.minimumTemperature" [editMode]="editMode"
                                      [includeMargin]="false">
                        <input class="input-group form-control" type="number"
                               [(ngModel)]="goodsItem.minimumTemperature"/>
                      </app-form-field>
                      <app-form-field label="Maximum temperature (°C)" class="col col-md-5"
                                      [(value)]="goodsItem.maximumTemperature" [editMode]="editMode"
                                      [includeMargin]="false">
                        <input class="input-group form-control" type="number"
                               [(ngModel)]="goodsItem.maximumTemperature"/>
                      </app-form-field>
                    </div>
                  </div>
                  <div class="col-12">
                    <app-goods-packaging [packaging]="goodsItem.outerPackaging" [editMode]="editMode"
                                         label="Outer package type"></app-goods-packaging>
                  </div>
                  @if (goodsItem.outerPackaging.typeOfPackages && !goodsItem.outerPackaging.typeOfPackages.bulk) {
                    <div class="col-12">
                      <label class="h2 fw-regular">Inner packages</label>
                      @if (editMode) {
                        <span class="form-field-optional text-secondary ms-1">(optional)</span>
                      }
                      @for (packaging of goodsItem.innerPackagingList; track $index) {
                        <app-goods-packaging [packaging]="packaging" [editMode]="editMode" label="Inner package type">
                          @if (editMode) {
                            <div class="col-auto d-flex align-items-center pt-5">
                              <button class="btn rounded-circle p-1 px-2 text-danger h1 mb-0"
                                      (click)="deleteInnerPackage(packaging)">
                                <i class="fa-light fa-trash-can"></i>
                              </button>
                            </div>
                          }
                        </app-goods-packaging>
                      }
                      @if (editMode) {
                        <div class="row mt-3">
                          <div class="col-auto">
                            <button class="btn btn-outline-primary text-decoration-none" (click)="addInnerPackage()">
                              <i class="fa-lg fa-light fa-plus"></i>
                              <span class="ps-2 d-none d-md-inline">Add inner package</span>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="col-12">
                    <label class="h2 fw-regular">Documents</label>
                    @if (editMode) {
                      <span class="form-field-optional text-secondary ms-1">(optional)</span>
                    }
                    @if (goodsItem.previousDocument) {
                      <div class="row">
                        <app-form-field label="Previous document" class="col col-md-7"
                                        [(value)]="goodsItem.previousDocument.type" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="utils.supportingDocumentTypeFormatter"
                                        [checkForErrors]="'Previous document type'">
                          <app-search [(ngModel)]="goodsItem.previousDocument.type" placeholder="Select document type"
                                      [options]="utils.documentTypes"
                                      [inputFormatter]="utils.supportingDocumentTypeFormatter"></app-search>
                        </app-form-field>
                        <app-form-field label="Reference number" [(value)]="goodsItem.previousDocument.identification"
                                        class="col col-md-3"
                                        [editMode]="editMode" [includeMargin]="false"
                                        [checkForErrors]="'Previous document number'">
                          <input class="input-group form-control"
                                 [(ngModel)]="goodsItem.previousDocument.identification"/>
                        </app-form-field>
                      </div>
                    }
                  </div>
                  @for (supportingDocument of goodsItem.supportingDocuments; track $index) {
                    <div class="col-12">
                      <div class="row">
                        <app-form-field label="Supporting document" class="col col-md-7" [truncateReadOnly]="true"
                                        [(value)]="supportingDocument.type" [editMode]="editMode"
                                        [includeMargin]="false" [formatter]="utils.documentTypeFormatter"
                                        [checkForErrors]="'Supporting document type'">
                          <app-search [(ngModel)]="supportingDocument.type"
                                      [inputFormatter]="utils.documentTypeFormatter" required
                                      [searchFunction]="utils.findDocumentTypes"
                                      placeholder="Select a document type"></app-search>
                        </app-form-field>
                        <app-form-field label="Reference number" [(value)]="supportingDocument.referenceNumber"
                                        class="col col-md-3"
                                        [editMode]="editMode" [includeMargin]="false"
                                        [checkForErrors]="'Supporting document number'">
                          <input class="input-group form-control" required
                                 [(ngModel)]="supportingDocument.referenceNumber"/>
                        </app-form-field>
                        @if (editMode) {
                          <div class="col-auto d-flex align-items-center pt-5">
                            <button class="btn rounded-circle p-1 px-2 text-danger h1 mb-0"
                                    (click)="deleteSupportingDocument(supportingDocument)">
                              <i class="fa-light fa-trash-can"></i>
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="col-12">
                    @if (editMode) {
                      <div class="row mt-3">
                        <div class="col-auto">
                          <button class="btn btn-outline-primary text-decoration-none"
                                  (click)="addSupportingDocument()">
                            <i class="fa-lg fa-light fa-plus"></i>
                            <span class="ps-2 d-none d-md-inline">Add supporting document</span>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tab-item>
      <app-tab-item [templateRef]="equipmentRef">
        <span class="tab-item">
          <span errorIndicator [predicate]="equipmentPredicate" [overrideRef]="elementRef"></span>
          <span>Equipment</span>
        </span>
        <ng-template #equipmentRef>
          <app-consignment-equipments-table [data]="equipmentListSummaries" [editable]="isEditable"
                                            [editMode]="editMode"
                                            [showPlacement]="true" [(goodsItem)]="goodsItem"
                                            [houseConsignmentNumber]="houseConsignment?.consignmentNumber"></app-consignment-equipments-table>
        </ng-template>
      </app-tab-item>
      @if (consignmentProcess.filing.filingType === 'F50') {
        <app-tab-item [templateRef]="vehiclesRef">
          <span class="tab-item">Vehicles</span>
          <ng-template #vehiclesRef>
            <app-consignment-vehicles-table [data]="goodsItem.passiveBorderTransportMeans" [editable]="isEditable"
                                            [(editMode)]="editMode"></app-consignment-vehicles-table>
          </ng-template>
        </app-tab-item>
      }
    </app-tab-panel>
  </div>
  @if (!consignmentProcess.fromVisit) {
    <div class="modal-footer">
      <div class="d-flex flex-grow-1">
        <div class="container">
          <div class="row mx-4">
            <div class="col-auto">
              <button type="button" class="btn btn-outline-danger" (click)="remove()">Remove</button>
            </div>
            <div class="col-auto ms-auto">
              @if (!editMode) {
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close"
                >
                  Close
                </button>
              }
              @if (editMode) {
                <button type="button" class="btn btn-outline-secondary" (click)="toggleEdit()">
                  Cancel
                </button>
              }
            </div>
            <div class="col-auto">
              @if (editMode) {
                @if (hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="toggleEdit()">
                    Ok
                  </button>
                }
                @if (!hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    Save
                  </button>
                }
              } @else {
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="toggleEdit()">
                    Edit
                  </button>
                }
                @if (allowedToDeclare && hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    {{consignmentProcess?.cancelled ? "Re-open" : "Update"}}
                  </button>
                }
              }
              <ng-template #readMode>
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="toggleEdit()">
                    Edit
                  </button>
                }
                @if (allowedToDeclare && hasBeenDeclared) {
                  <button type="button" class="btn btn-primary" (click)="saveOrDeclare()">
                    {{consignmentProcess?.cancelled ? "Re-open" : "Update"}}
                  </button>
                }
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<div class="w-100 h-100 position-absolute d-flex flex-column-reverse" [ngClass]="showSubModal ? '' : 'd-none'">
  <div class="w-100 h-100 position-absolute modal-backdrop show" (click)="closeConsignmentSubModal()"></div>
  <div class="bg-body" style="z-index: 1050; height: calc(100% - 110px);">
    <ng-template #subModalContainer></ng-template>
  </div>
</div>
